import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { EarnSheetProvider, useEarnSheetContext } from './context/EarnSheetProvider'
import { useEarnModel } from './hooks/useEarnModel'
import { useEarnTracking } from './hooks/useEarnTracking'
import { EARN_MODEL, EARN_SHEET_ACTION_TYPE, EarnAsset } from './types'
import { EarnDirectView } from './views/direct/EarnDirectView'
import { EarnEmbeddedView } from './views/embedded/EarnEmbeddedView'

export const Earn = () => (
  <EarnSheetProvider>
    <EarnContent />
  </EarnSheetProvider>
)

const EarnContent = () => {
  const { t } = useTranslation()
  const { trackPageView } = useEarnTracking()
  const { handleSheetOpen } = useEarnSheetContext()
  const earnModel = useEarnModel()

  const handleDeposit = useCallback(
    (asset: EarnAsset) => {
      handleSheetOpen({
        type: EARN_SHEET_ACTION_TYPE.DEPOSIT,
        header: t('earn.depositSheet.header'),
        selectedCurrency: asset.asset,
        portfolioId: asset.portfolioId ?? undefined,
        productName: asset.productName,
      })
    },
    [handleSheetOpen, t]
  )

  const handleWithdraw = useCallback(
    (asset: EarnAsset) => {
      handleSheetOpen({
        type: EARN_SHEET_ACTION_TYPE.WITHDRAW,
        header: t('earn.withdrawSheet.header'),
        selectedCurrency: asset.asset,
        portfolioId: asset.portfolioId ?? undefined,
        productName: asset.productName,
      })
    },
    [handleSheetOpen, t]
  )

  useEffect(() => {
    trackPageView('home')
  }, [trackPageView])

  if (earnModel === EARN_MODEL.DIRECT) {
    return <EarnDirectView onDeposit={handleDeposit} onWithdraw={handleWithdraw} />
  }

  return <EarnEmbeddedView onDeposit={handleDeposit} onWithdraw={handleWithdraw} />
}
